/**
 * Retrieves the authentication token.
 * @returns {string|null} - The auth token or null if not found.
 */
export const getAuthToken = () => {

  if (typeof window !== 'undefined') {
    return localStorage.getItem('token');
  }
  return null;
};
export const storeAuthToken = (token) => {

  if (typeof window !== 'undefined') {
    localStorage.setItem('token', token);
    // Notify AuthContext so profile loads after SPA login (no full refresh needed)
    window.dispatchEvent(new Event('eventox-auth-changed'));
    return;
  }
  return null;
};



export const getUserDetails = () => {
  if (typeof window !== 'undefined') {
    const authUser = localStorage.getItem('authUser');
    if (authUser) {
      const userDetails = JSON.parse(authUser)?.user;
      return userDetails;
    }
  }
  return null;
};


export const storeUserDetails = (userDetails) => {
  if (typeof window !== 'undefined') {
    return localStorage.setItem('authUser', JSON.stringify({ user: userDetails }));
  }
  return null;
};

export const storeOrganizerId = (organizerId) => {
  if (typeof window !== 'undefined') {
    return localStorage.setItem('organizerId', organizerId);
  }
  return null;
};
